import React from 'react';
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
} from '@material-ui/core';
import MaskedInput from 'react-text-mask';
import { STATE_ABBR } from '../../constants';
import {
  stripAddress,
  stripCity,
  stripName,
  stripPhone,
  stripPostalCode,
} from '../../core/validate';

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      // prettier-ignore
      mask={['(', /[1-9]/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

const BillingInfo = (props) => {
  const { info, setInfo } = props;

  const changeInfo = (data) => {
    for (const key in data) {
      const val = data[key];

      if (info[key] !== val) {
        setInfo({ ...info, ...data });
        break;
      }
    }
  };

  const handleName = (e) => changeInfo({ name: stripName(e.target.value) });
  const handleAddress = (e) => {
    changeInfo({ address: stripAddress(e.target.value) });
  };
  const handlePhone = (e) => changeInfo({ phone: stripPhone(e.target.value) });
  const handleCity = (e) => changeInfo({ city: stripCity(e.target.value) });
  const handleState = (e) => changeInfo({ state: e.target.value });
  const handlePostalCode = (e) =>
    changeInfo({ postalCode: stripPostalCode(e.target.value) });

  return (
    <div>
      <Typography gutterBottom={true}>Billing Information</Typography>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            color="primary"
            label="Full Name"
            fullWidth
            value={info.name}
            onChange={handleName}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            color="primary"
            label="Phone"
            fullWidth
            value={info.phone}
            onChange={handlePhone}
            InputProps={{
              inputComponent: TextMaskCustom,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            color="primary"
            label="Street Address"
            fullWidth
            value={info.address}
            onChange={handleAddress}
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <TextField
            variant="outlined"
            color="primary"
            label="City"
            fullWidth
            value={info.city}
            onChange={handleCity}
          />
        </Grid>
        <Grid item xs={6} sm={2}>
          <TextField
            labelId="BILLING_INFO_STATE_LABEL"
            value={info.state}
            onChange={handleState}
            variant="outlined"
            label="State"
            fullWidth
            select
          >
            {STATE_ABBR.map((st) => (
              <MenuItem value={st} key={`BILLING_INFO_STATE_${st}`}>
                {st}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            variant="outlined"
            color="primary"
            label="Postal Code"
            fullWidth
            value={info.postalCode}
            onChange={handlePostalCode}
          />
        </Grid>
      </Grid>
    </div>
  );
};
export default BillingInfo;
